<template>
  <b-modal
    ref="modal"
    class="modal-prompt"
    content-class="rounded-10 position-relative"
    size="sm"
    :visible="visible"
    no-close-on-backdrop
    no-close-on-esc
    :centered="true"
  >
    <template #modal-header>
      <h3>{{ title }}</h3>
      <i class="icon-X" @click.prevent="onClose"> </i>
    </template>
    <template #default>
      <b-form class="modal-prompt-form" @submit.stop.prevent>
        <b-form-input
          id="feedback-user"
          v-model="userInput"
          class="flex-1"
          :state="validationState"
          :type="inputType"
          :placeholder="placeholder"
        ></b-form-input>
        <b-form-invalid-feedback :state="validationState">{{
          validationError
        }}</b-form-invalid-feedback>
        <b-form-valid-feedback :state="validationState"></b-form-valid-feedback>
      </b-form>
    </template>
    <template #modal-footer>
      <b-button size="md" variant="primary" class="confirm" @click="onConfirm">
        {{ confirmText }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      promise: null,
      userInput: '',
      isSubmitting: false,
      title: 'title',
      placeholder: 'placeholder',
      inputType: 'text',
      confirmText: '確定',
      validation: () => ({error: '', isPass: true}),
    };
  },
  watch: {
    userInput() {
      this.isSubmitting = false;
    },
  },
  computed: {
    validationState() {
      if (!this.userInput && !this.isSubmitting) return null;
      if (!this.validation) return true;
      const validationResult = this.validation(this.userInput);
      return validationResult?.isPass ?? !!validationResult;
    },
    validationError() {
      if (!this.validation) return '';
      const validationResult = this.validation(this.userInput);
      return validationResult?.error || '';
    },
  },
  methods: {
    init() {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.promise = {resolve, reject};
      });
    },
    onClose() {
      this.promise.resolve(null);
      this.destroyVm();
    },
    onConfirm() {
      this.isSubmitting = true;
      if (!this.validationState) return;
      this.promise.resolve(this.userInput);
      this.destroyVm();
    },
    destroyVm() {
      this.visible = false;
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .modal-content {
  width: 300px;
  margin: 0 auto;
  .modal-header {
    color: #606266;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .modal-body {
    padding: $spacing-s;
    min-height: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .modal-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: $spacing-xs;
  }
}
.icon-X {
  font-size: 32px;
  cursor: pointer;
  color: $primary;
  &:hover {
    color: $hover-primary;
  }
}
.modal-prompt-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>
